document.addEventListener('DOMContentLoaded', () => {
  const addBtn = document.querySelector('[id^="ProductSubmitButton"], [id$="-submit"][name="add"], button[name="add"]');
  if (!addBtn) return;

  const currency = addBtn.dataset.currency || 'USD';

  function formatCurrency(value, currencyCode = 'USD') {
  return new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(value);
}

  function updateButtonLabel() {
    const price = parseFloat(addBtn.dataset.price);
    const span = addBtn.querySelector('span');
    if (!span) return;

    if (!price || isNaN(price)) {
      span.textContent = 'ADD TO BAG';
      return;
    }

    span.textContent = `ADD TO BAG — ${formatCurrency(price, currency)}`;
  }

  // Initial render
  updateButtonLabel();

  // Update when variant changes
  document.addEventListener('variant:change', (event) => {
    const variant = event.detail?.variant;
    if (variant && variant.price) {
      addBtn.dataset.price = variant.price / 100;
      updateButtonLabel();
    }
  });
  /* START: dynamic price injection for Add-to-Cart button */
function findPagePriceEl() {
  return document.querySelector('.price, .price-item, .product__price, .price-item--regular, .product-price');
}

function updateButtonPrices() {
  const priceEl = findPagePriceEl();
  const priceText = priceEl ? priceEl.textContent.trim() : '';

  // Update any dynamic-price spans (we added these in buy-buttons.liquid)
  document.querySelectorAll('.dynamic-price').forEach(sp => {
    sp.textContent = priceText || sp.textContent;
  });
}

// Run once on load (inside the same DOMContentLoaded handler)
updateButtonPrices();

// Listen for common variant change events emitted by themes
document.addEventListener('variant:change', updateButtonPrices);
document.addEventListener('variantChange', updateButtonPrices);
document.addEventListener('product:variant:change', updateButtonPrices);

// Watch the price element for DOM updates as a reliable fallback
const priceNode = findPagePriceEl();
if (priceNode) {
  const obs = new MutationObserver(updateButtonPrices);
  obs.observe(priceNode, { childList: true, subtree: true, characterData: true });
}

// Optional safety net (remove if you don't want interval)
const _dynamicPriceInterval = setInterval(updateButtonPrices, 1500);
/* END: dynamic price injection for Add-to-Cart button */

});